module.exports = __webpack_public_path__ + "img/itx-file-type-ods.a587e1e5.svg";